import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tenants from "@/pages/Tenants";
import Reservations from "@/pages/Reservations";
import Dues from "@/pages/Dues";
import Finances from "@/pages/Finances";
import Documents from "@/pages/Documents";
import Settings from "@/pages/Settings";
import PaymentResult from "@/pages/PaymentResult";
import PublicSite from "@/pages/PublicSite";
import Inquiries from "@/pages/Inquiries";
import SiteContent from "@/pages/SiteContent";
import Guide from "@/pages/Guide";
import { Loader2 } from "lucide-react";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-linen"><Loader2 className="w-6 h-6 animate-spin text-teak" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const RoleGate = ({ allow, children }) => {
  const { user } = useAuth();
  if (user && !allow.includes(user.role)) return <Navigate to="/admin" replace />;
  return children;
};

const Page = ({ children }) => <Protected>{children}</Protected>;

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicSite />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Page><Dashboard /></Page>} />
              <Route path="/admin/tenants" element={<Page><Tenants /></Page>} />
              <Route path="/admin/reservations" element={<Page><Reservations /></Page>} />
              <Route path="/admin/dues" element={<Page><Dues /></Page>} />
              <Route path="/admin/inquiries" element={<Page><Inquiries /></Page>} />
              <Route path="/admin/finances" element={<Page><RoleGate allow={["admin", "staff"]}><Finances /></RoleGate></Page>} />
              <Route path="/admin/documents" element={<Page><Documents /></Page>} />
              <Route path="/admin/content" element={<Page><RoleGate allow={["admin"]}><SiteContent /></RoleGate></Page>} />
              <Route path="/admin/settings" element={<Page><RoleGate allow={["admin"]}><Settings /></RoleGate></Page>} />
              <Route path="/admin/guide" element={<Page><Guide /></Page>} />
              <Route path="/payment/success" element={<Protected><PaymentResult /></Protected>} />
              <Route path="/payment/cancel" element={<Protected><PaymentResult /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
